import OrderAddressBox from 'components/pages/dashboard/ParcelOrder/components/orderAddressPicker/OrderAddressBox';
import OrderClientBox from 'components/pages/dashboard/ParcelOrder/components/orderPersonPicker/OrderClientBox';
import { peopleAddress } from 'global/Models/addressModel';
import { client } from 'global/Models/clientModel';
import { lockerInfo, packageCreate } from 'global/Models/omOrderModel';
import { FC, useCallback, useMemo } from 'react';
import { HiOutlineArrowDownOnSquare } from 'react-icons/hi2';

interface IOrderDestinationSection {
  setPackages: React.Dispatch<React.SetStateAction<packageCreate[]>>;
  index: number;
  packages: packageCreate[];
}

const BranchOrderDestinationSection: FC<IOrderDestinationSection> = ({ setPackages, index, packages }) => {
  //state
  // const { customerUser, userPerson, userProfile } = useSelector((state: RootState) => state.user);

  //effect
  // useEffect(() => {
  //   if (customerUser && userPerson && userProfile) getMyClient();
  // }, [userPerson, userProfile, customerUser]);

  const addClient = useCallback(
    (client?: client) => {
      setPackages((prevState) => {
        const tempPackages = prevState.map((c, i) => {
          if (i !== index) return c;
          return { ...c, receiverClient: client };
        });
        return tempPackages;
      });
    },
    [index, packages]
  );
  const addAddress = useCallback(
    (address?: peopleAddress) => {
      setPackages((prevState) => {
        const tempPackages = prevState.map((a, i) => {
          if (i !== index) return a;
          return { ...a, receiverAddress: address, destinationCity: { id: address?.address.cityId, jetId: address?.address.jetCityId } };
        });
        return tempPackages;
      });
    },
    [index, packages]
  );
  const addLockerAddress = useCallback(
    (lockerInfo?: lockerInfo) => {
      setPackages((prevState) => {
        const tempPackages = prevState.map((a, i) => {
          if (i !== index) return a;
          return {
            ...a,
            lockerInfo,
          };
        });
        return tempPackages;
      });
    },
    [index, packages]
  );

  // const getMyClient = async () => {
  //   await ApiService.post(endpointUrls.clientGetAll, {
  //     customerId: customerUser?.customerId,
  //   })
  //     .then((res: IBackendSearchGeneric<client>) => {
  //       handleApiThenGeneric<IBackendSearchGeneric<client>, client[]>({
  //         res,
  //         notifFail: false,
  //         notifSuccess: false,
  //         onSuccessData: (data) => {
  //           if (data.length > 0) addClient(data[data.length - 1]);
  //         },
  //       });
  //     })
  //     .catch(() => localApiCatcher(errorResponse));
  // };

  const client = useMemo(() => packages[index].receiverClient, [packages, index]);
  const address = useMemo(() => packages[index].receiverAddress, [packages, index]);

  const lockerAddress = useMemo(() => packages[index].lockerInfo, [packages, index]);

  return (
    <div className='flex flex-col gap-2'>
      <span className='flex items-center gap-1 mx-auto font-bold text-t-primary-color inherit-color'>
        <HiOutlineArrowDownOnSquare className='text-xl' />
        توزیع / گیرنده
      </span>
      <OrderClientBox setClient={addClient} client={client} title='گیرنده' />
      <OrderAddressBox
        setAddress={addAddress}
        address={address}
        peopleAddressTypeId={2}
        packages={packages}
        index={index}
        setLockerAddress={addLockerAddress}
        lockerAddress={lockerAddress}
        isNormalOrder={false}
      />
    </div>
  );
};

export default BranchOrderDestinationSection;
